import React from "react";

import { inputLayerGroups } from "fond/layers";
import { useAppSelector } from "fond/utils/hooks";
import { useStackedNavigationContext } from "fond/widgets";

import ImportDataProgress from "./polygon/ImportDataProgress";

const ImportData: React.FC = () => {
  const { activeLayerGroupId } = useAppSelector((state) => state.project);
  const { clear } = useStackedNavigationContext();

  const activeLayerName = activeLayerGroupId && inputLayerGroups[activeLayerGroupId]?.name;

  return <ImportDataProgress title={activeLayerName} onSuccess={clear} onCancel={clear} />;
};

export default ImportData;
